import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from "@angular/core";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { ReuseOnDataRouteStrategy } from "./core/routing/reuse-strategy";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbThemeModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { OKTA_CONFIG, OktaAuthModule } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { provideEchartsCore } from "ngx-echarts";

import oktaConfig from "./app.config.okta";
import { assertOktaConfig } from "./core/auth/env-validation";
import { APP_ROUTES } from "./app.routes";
import { DEFAULT_THEME } from "./@theme/styles/theme.default";
import { COSMIC_THEME } from "./@theme/styles/theme.cosmic";
import { CORPORATE_THEME } from "./@theme/styles/theme.corporate";
import { DARK_THEME } from "./@theme/styles/theme.dark";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { httpsEnforceInterceptor } from "./core/interceptors/https-enforce.interceptor";
import { errorInterceptor } from "./core/interceptors/error.interceptor";

assertOktaConfig(oktaConfig.oidc);
const oktaAuth = new OktaAuth(oktaConfig.oidc);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(APP_ROUTES),
    { provide: RouteReuseStrategy, useClass: ReuseOnDataRouteStrategy },
    provideHttpClient(
      withInterceptors([
        httpsEnforceInterceptor,
        authInterceptor,
        errorInterceptor,
      ]),
    ),
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    // ng2-charts v10: provideCharts replaces NgChartsModule.forRoot.
    provideCharts(withDefaultRegisterables()),
    provideEchartsCore({ echarts: () => import("echarts") }),
    // Vendor NgModule forRoot() imports — allowed per
    // .claude/.rules/angular.md as scoped exceptions (Nebular + Okta).
    importProvidersFrom(
      BrowserAnimationsModule,
      OktaAuthModule,
      NbThemeModule.forRoot({ name: "default" }, [
        DEFAULT_THEME,
        COSMIC_THEME,
        CORPORATE_THEME,
        DARK_THEME,
      ]),
      NbEvaIconsModule,
      NbSidebarModule.forRoot(),
      NbSpinnerModule,
      NbMenuModule.forRoot(),
      NbDatepickerModule.forRoot(),
      NbTimepickerModule.forRoot(),
      NbDialogModule.forRoot(),
      NbWindowModule.forRoot(),
      NbToastrModule.forRoot({ duration: 5000 }),
    ),
  ],
};
